import MoreVertIcon from '@mui/icons-material/MoreVert';
import {
  Button,
  List,
  ListItem,
  Popover,
  TableCell,
  TableRow,
} from '@mui/material';
import React, { useState } from 'react';
import Label from '../elements/label/Label';
import EditUser from './EditUser';
import ResetPassword from './ResetPassword';
import DisableUser from './DisableUser';
import useAuthToken from '../../hooks/getUserData';

export default function ListContent({
  row,
  columns,
  index,
  tableName,
  fetchData,
  setMessage,
  setSnackbarOpen,
}) {
  const token = useAuthToken();

  const { status, id } = row;

  const [menuAnchor, setMenuAnchor] = useState(null);
  const handleMenuOpen = (event) => {
    setMenuAnchor(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
  };

  return (
    <TableRow hover key={id}>
      {columns.map((column, columnIndex) => {
        const { id: columnId } = column;
        let cellContent;

        if (columnId === 'status') {
          cellContent = (
            <Label color={status === 'active' ? 'success' : 'default'}>
              {status}
            </Label>
          );
        } else if (columnId === 'actions') {
          cellContent = (
            <div>
              <Button onClick={handleMenuOpen}>
                <MoreVertIcon />
              </Button>
              <Popover
                anchorEl={menuAnchor}
                open={Boolean(menuAnchor)}
                onClose={handleMenuClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}>
                <List>
                  <ListItem>
                    <EditUser
                      user={row}
                      fetchData={fetchData}
                      token={token}
                      setMessage={setMessage}
                      setSnackbarOpen={setSnackbarOpen}
                    />
                  </ListItem>
                  <ListItem>
                    <ResetPassword
                      user={row}
                      fetchData={fetchData}
                      token={token}
                      setMessage={setMessage}
                      setSnackbarOpen={setSnackbarOpen}
                    />
                  </ListItem>
                  <ListItem>
                    <DisableUser
                      user={row}
                      fetchData={fetchData}
                      token={token}
                      setMessage={setMessage}
                      setSnackbarOpen={setSnackbarOpen}
                    />
                  </ListItem>
                </List>
              </Popover>
            </div>
          );
        } else if (columnId === 'sno') {
          cellContent = index + 1;
        } else if (columnId === 'url_username') {
          cellContent = row['registry_url'] || row['username'] || 'NA';
        } else if (columnId === 'name') {
          cellContent = `${row['first_name']} ${row['last_name']}` || 'NA';
        } else {
          cellContent = row[columnId] || 'NA';
        }

        return (
          <TableCell
            key={columnId}
            align="center"
            sx={{
              width: columnId === 'name' ? '20%' : 'auto',
              padding: '8px 16px',
            }}>
            {cellContent}
          </TableCell>
        );
      })}
    </TableRow>
  );
}
